import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS 
} from "./actionTypes"

import { 
  getAdminDashboardStickyColumnsError,
  getAdminDashboardStickyColumnsSuccess,
  updateAdminDashboardStickyColumnsError,
  updateAdminDashboardStickyColumnsSuccess 
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminDahsboardStickyColumns() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_admin_dashboards`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getAdminDashboardStickyColumnsError(error))
  }
}

function* onUpdateAdminDashboardStickyColumns(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_admin_dashboards/${action?.payload?.user_col_pref_admin_dashboard?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAdminDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateAdminDashboardStickyColumnsError(error))
  }
}

function* adminDashboardColumnPreferenceSaga() {
  yield takeEvery(GET_ADMIN_DASHBOARD_STICKY_COLUMNS, onGetAdminDahsboardStickyColumns)
  yield takeEvery(UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS, onUpdateAdminDashboardStickyColumns)
}

export default adminDashboardColumnPreferenceSaga;
